import type { TFunction } from 'i18next'

/**
 * A record of the carrier or broker book, as far as a picker needs to tell two of one name
 * apart. The books' summaries carry all of it; a record named elsewhere — a broker the
 * paste's answer offered — may carry only its id and name.
 */
export interface BookRecord {
  id: string
  name: string
  city?: string
  state?: string
  mcNumber?: string | null
  active?: boolean
  complianceState?: string
}

/**
 * The line under a record's name in a picker: where it is and its MC number — what tells
 * two companies of one name apart — and whether it is one we stopped working with, or one
 * whose paperwork has lapsed. Its own module, so the picker's file only exports components.
 */
export function describeBookRecord(record: BookRecord, t: TFunction): string | undefined {
  const parts = [
    record.city !== undefined && record.state !== undefined ? `${record.city}, ${record.state}` : undefined,
    record.mcNumber != null && record.mcNumber !== '' ? t('picker.mc', { number: record.mcNumber }) : undefined,
    record.active === false ? t('picker.inactive') : undefined,
    record.complianceState === 'Blocked' ? t('picker.blocked') : undefined,
  ].filter((part): part is string => part !== undefined)

  return parts.length === 0 ? undefined : parts.join(' · ')
}
